<button
  mat-icon-button
  type="button"
  class="bell-trigger"
  [matMenuTriggerFor]="bellMenu"
  [matBadge]="unreadCount()"
  [matBadgeHidden]="unreadCount() === 0"
  matBadgeColor="warn"
  matBadgeSize="small"
  aria-label="Notifications"
>
  <mat-icon>notifications</mat-icon>
</button>

<mat-menu #bellMenu="matMenu" xPosition="before" class="bell-menu">
  <div class="bell-menu__head">
    <strong>Notifications</strong>
    <span class="bell-menu__head-actions">
      <button mat-button type="button" (click)="markAllRead($event)" [disabled]="unreadCount() === 0">
        Mark all read
      </button>
      <button mat-button type="button" (click)="clearAll($event)" [disabled]="notifications().length === 0">
        Clear
      </button>
    </span>
  </div>
  <mat-divider></mat-divider>

  @if (notifications().length === 0) {
    <div class="bell-menu__empty">You're all caught up.</div>
  } @else {
    @for (n of notifications(); track n.id) {
      <button mat-menu-item type="button" class="bell-item" [class.bell-item--unread]="!n.read" (click)="open(n)">
        <mat-icon class="bell-item__icon">{{ iconFor(n.kind) }}</mat-icon>
        <span class="bell-item__body">
          <span class="bell-item__title">{{ n.title }}</span>
          @if (n.detail) {
            <span class="bell-item__detail">{{ n.detail }}</span>
          }
          <span class="bell-item__meta">{{ kindLabel[n.kind] }} · {{ n.at | date: 'MMM d, h:mm a' }}</span>
        </span>
      </button>
    }
  }
</mat-menu>
